
// @ts-nocheck
export default {
  props: ["promos", "promoSize", "className"],
  created() {},
};
